import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
/**
 * Periodically refreshes a JPEG snapshot of a live RTSP camera, served by
 * `/api/cameras/{id}/snapshot` (proxied from VST). We deliberately avoid live
 * WebRTC/HLS preview: VSS already records continuously, so the operational
 * view is clip-of-interest playback (see ClipPlayer); this snapshot just
 * confirms the camera is online and aimed correctly.
 */
export function SnapshotPreview({ cameraId, intervalMs = 5000, }) {
    const [tick, setTick] = useState(() => Date.now());
    const [errored, setErrored] = useState(false);
    useEffect(() => {
        setErrored(false);
        setTick(Date.now());
        const handle = window.setInterval(() => {
            setErrored(false);
            setTick(Date.now());
        }, intervalMs);
        return () => window.clearInterval(handle);
    }, [cameraId, intervalMs]);
    const src = `/api/cameras/${encodeURIComponent(cameraId)}/snapshot?ts=${tick}`;
    return (_jsxs("div", { className: "video-wrap", children: [errored ? (_jsx("div", { style: {
                    width: '100%',
                    minHeight: 240,
                    background: '#000',
                    borderRadius: 'var(--r)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--ey-muted)',
                    fontSize: 13,
                }, children: "Snapshot unavailable (VST may not have registered this camera yet)" })) : (_jsx("img", { src: src, alt: `snapshot-${cameraId}`, onError: () => setErrored(true), style: { width: '100%', borderRadius: 'var(--r)', background: '#000', minHeight: 240 } }, tick)), _jsx("div", { style: { marginTop: 8, fontSize: 12, color: 'var(--ey-muted)' }, children: !errored && (_jsxs("span", { className: "tag ok", style: { display: 'inline-block' }, children: ["\u25CF SNAPSHOT (auto-refresh ", Math.round(intervalMs / 1000), "s)"] })) })] }));
}
